import { Box, Checkbox, Divider, styled, Typography } from "@mui/material";
import React, { Fragment, useState } from "react";
import Cancel from "../../assets/svg/Cancel";
import CheckmarkBorder from "../../assets/svg/checkmarkBorder";
import CheckTick from "../../assets/svg/checkTick";
import CloseCall from "../../components/CloseCallPopup";
import CustomButton from "../../components/common/CustomButton";
import { apiPatch, apiPut } from "../../utils/Api/ApiCalls";
import { API_ROUTES } from "../../utils/Api/ApiConfig";
import { colors } from "../../utils/colors/Index";
import { formatChangeDate, formattedTime } from "../../utils/dateFormat";
import Delete from "../../assets/svg/Delete";

function RecentCalls({
  item,
  setLoader,
  setCallData,
  showSelectCheckbox = false,
  onSelect,
  onDelete,
  closeCallApiType = "default",
  fetchCallData,
  isChecked = false,
}) {
  const target1 = item?.target?.[0]?.status === "achieved";

  const targetId1 = item?.target?.[0]?._id;
  const [open, setOpen] = useState(false);
  const [selectedCall, setSelectedCall] = useState(null);
  const callsname = item?.callName || "";
  const handleCheckboxClick = async (callId, targetId, price, key) => {
    // const fetchParams = () => {
    //   if (key === "Target Price 1") {
    //     return {
    //       targetIds: [targetId],
    //       callId: callId,
    //       status: "open",
    //     };
    //   } else if (key === "Target Price 2") {
    //     if (target1) {
    //       return {
    //         targetIds: [targetId],
    //         callId: callId,
    //         status: "closed",
    //       };
    //     } else {
    //       return {
    //         targetIds: [targetId, targetId1],
    //         callId: callId,
    //         status: "closed",
    //       };
    //     }
    //   } else if (key === "Stop Loss") {
    //     return {
    //       targetIds: [targetId],
    //       callId: callId,
    //       status: "closed",
    //     };
    //   } else {
    //     return {
    //       field: key,
    //       callId: callId,
    //     };
    //   }
    // };
    const fetchParams = () => {
      if (key === "Target Price 1") {
        return {
          targetIds: [targetId],
          callId: callId,
          status: "Open",

          action: `${callsname} ${key} price ${price} will be opened `,
        };
      } else if (key === "Target Price 2") {
        if (target1) {
          return {
            targetIds: [targetId],
            callId: callId,
            status: "closed",
            action: `${callsname} ${key} price ${price} have been closed `,
          };
        } else {
          return {
            targetIds: [targetId, targetId1],
            callId: callId,
            status: "closed",
            action: `${callsname} ${key} price ${price} have been closed `,
          };
        }
      } else if (key === "Stop Loss") {
        return {
          targetIds: [targetId],
          callId: callId,
          status: "closed",
          action: `${callsname} ${key} price ${price} have been closed `,
        };
      } else {
        return {
          field: key,
          callId: callId,
          action: `${callsname} will be updated `,
        };
      }
    };
    const body = fetchParams();

    try {
      setLoader(true);
      const response = await apiPut(API_ROUTES.PUT_CALLS, body);
      if (response?.status === 200) {
        setCallData((prev) => {
          const a = [...prev]
            .flat()
            ?.filter((call) => call._id !== response?.data.call._id);
          a.unshift(response?.data?.call);
          console.log(a);
          return a;
        });
        setLoader(false);
      }
    } catch (err) {
      console.log(err);
      setLoader(false);
    }
  };
  // const [checked, setChecked] = useState(false);

  const handleSelect = (event) => {
    // setChecked(event.target.checked);
    if (onSelect) {
      onSelect(item._id, event.target.checked);
    }
  };

  // const handleCloseCall = async (item, _id) => {
  //   console.log(closeCallApiType);

  //   if (item?.target?.[0]?.status !== "achieved") {
  //     setOpen(true);
  //     setSelectedCall(item);
  //   } else {
  //     setLoader(true);
  //     const body = {
  //       callId: _id,
  //       targetIds: [],
  //       status: "closed",
  //       action: `${callsname} will be closed `,
  //     };
  //     try {
  //       // const response = await apiPut(API_ROUTES.PUT_CALLS, body);
  //       let response;
  //       // const response = await apiPut(API_ROUTES.PUT_CALLS, body);
  //       if (closeCallApiType === "default") {
  //         response = await apiPut(API_ROUTES.PUT_CALLS, body);
  //         setLoader(false);
  //       } else if (closeCallApiType === "second") {
  //         response = await apiPatch(API_ROUTES.EDIT_CALL, {
  //           callIds: [_id],
  //           action: "closed",
  //         });
  //         setLoader(false); // 👈 Second page API
  //       }
  //       if (response?.statusCode === 200) {
  //         setCallData((prev) => {
  //           const a = [...prev]
  //             .flat()
  //             ?.filter((call) => call._id !== response?.data.call._id);
  //           a.unshift(response?.data?.call);
  //           console.log(a);
  //           return a;
  //         });
  //         fetchCallData();
  //         setLoader(false);
  //       }
  //     } catch (err) {
  //       console.log(err);
  //       setLoader(false);
  //     }
  //   }
  // };
  const handleCloseCall = async (item, _id) => {
    if (item?.target?.[0]?.status !== "achieved") {
      setOpen(true);
      setSelectedCall(item);
    } else {
      setLoader(true);
      const body = {
        callId: _id,
        targetIds: [],
        status: "closed",
        action: `${callsname} will be closed `,
      };
      try {
        // const response = await apiPut(API_ROUTES.PUT_CALLS, body);
        let response;
        // const response = await apiPut(API_ROUTES.PUT_CALLS, body);
        if (closeCallApiType === "default") {
          response = await apiPut(API_ROUTES.PUT_CALLS, body); // 👈 First page API
        } else if (closeCallApiType === "second") {
          response = await apiPatch(API_ROUTES.EDIT_CALL, {
            callIds: [_id],
            action: "closed",
          });
          // 👈 Second page API
        }
        setLoader(false);
        if (response?.statusCode === 200) {
          setCallData((prev) => {
            const a = [...prev]
              .flat()
              ?.filter((call) => call._id !== response?.data.call._id);
            a.unshift(response?.data?.call);
            console.log(a);
            return a;
          });
          fetchCallData();
          setLoader(false);
        }
      } catch (err) {
        console.log(err);
        setLoader(false);
      }
    }
  };
  const handleChecked = (data, subData) => {
    return subData?.status === "achieved";
  };
  const handleDisabled = (data, subData, array, index) => {
    const checked =
      array?.some((item) => item.status === "achieved") &&
      array.length - 1 === index;
    return checked || data?.status === "closed";
  };
  return (
    <Container>
      {showSelectCheckbox && (
        <Checkbox
          checked={isChecked}
          disableRipple
          onChange={handleSelect}
          sx={{ marginRight: "0.5rem" }}
        />
      )}
      <StockCard sx={{ position: "relative" }}>
        <CheckboxContainer>
          <Header>
            <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
              <Info>
                <Typography
                  variant="body2"
                  fontWeight={600}
                  color={colors.text.primary}
                >
                  {item?.callName}
                </Typography>

                <DateProfit>
                  <Typography fontSize={12} color={colors.text.tertiary}>
                    {formatChangeDate(item?.createdDate)}
                  </Typography>
                  <Typography fontSize={12} color={colors.text.tertiary}>
                    | Profit potential
                  </Typography>
                  <Typography fontSize={10} color={colors.blue}>
                    {item?.profitPotential}%
                  </Typography>
                </DateProfit>
              </Info>
              <Box
                sx={{
                  background:
                    item?.actionType === "buy" ? "#EDFFF9" : "#FFF8F7",
                  padding: "3px 10px",
                  border: `1px solid ${
                    item?.actionType === "buy" ? "#45B68D" : "#E8503A"
                  }`,
                  borderRadius: "8px",
                }}
              >
                <Typography
                  sx={{
                    color: item?.actionType === "buy" ? "#45B68D" : "#E8503A",
                    fontWeight: 700,
                  }}
                >
                  {" "}
                  {item?.actionType?.toUpperCase()}
                </Typography>
              </Box>
            </Box>
            <EntryPrice>
              <Typography
                fontSize={12}
                fontWeight={600}
                color={colors?.text.primary}
              >
                Entry Price
              </Typography>
              <Typography fontSize={14} color={colors.lightGreen2}>
                ₹ {item?.entryPrice}
              </Typography>
            </EntryPrice>
          </Header>
          <Divider />
          <Targets>
            {item?.target?.map((value, index, array) => (
              <Fragment key={index}>
                <Target>
                  <Checkbox
                    icon={<CheckmarkBorder />}
                    checkedIcon={
                      array.length - 1 === index ? <Cancel /> : <CheckTick />
                    }
                    checked={handleChecked(item, value)}
                    disabled={handleDisabled(item, value, array, index)}
                    onChange={() =>
                      handleCheckboxClick(
                        item._id,
                        value._id,
                        value.price,
                        value.targetName
                      )
                    }
                  />
                  <Box>
                    <Typography fontSize={12} color={colors.text.tertiary}>
                      {value.targetName}
                    </Typography>
                    <Typography
                      fontSize={14}
                      color={colors.text.primary}
                      fontWeight={500}
                      mb={1}
                    >
                      ₹{value?.price}
                    </Typography>
                    {value.updatedDate && (
                      <>
                        <Divider variant="middle" />
                        <UpdatedDateTypography>
                          {formattedTime(value?.updatedDate)}
                        </UpdatedDateTypography>
                      </>
                    )}
                  </Box>
                </Target>
                {array.length - 1 !== index && (
                  <Divider
                    orientation="vertical"
                    variant="middle"
                    sx={{ height: "100%" }}
                  />
                )}
              </Fragment>
            ))}
          </Targets>
        </CheckboxContainer>
        <ActionButtonContainer>
          <BatchContainer isItem={item.status === "closed"}>
            <Typography sx={{ fontSize: 12, color: "#FBFBFB" }}>
              {item.status === "closed" ? "Closed" : "Open"}
            </Typography>
          </BatchContainer>
          <Divider
            orientation="vertical"
            variant="fullWidth"
            sx={{ height: "8rem" }}
          />
          {item.status === "closed" ? (
            <CustomButtonContainer>
              {item?.exitPrice && (
                <>
                  <Typography
                    fontSize={12}
                    fontWeight={500}
                    color={colors?.text.tertiary}
                  >
                    Exit Price:{" "}
                    <Typography
                      component={"span"}
                      fontSize={12}
                      fontWeight={600}
                      color={colors?.text.primary}
                    >
                      {item?.exitPrice}
                    </Typography>
                  </Typography>

                  <Typography
                    fontSize={12}
                    fontWeight={600}
                    color={colors?.text.primary}
                  >
                    {item?.exitReason}
                  </Typography>
                </>
              )}
            </CustomButtonContainer>
          ) : (
            <CustomButtonContainer>
              <CustomButton
                title="Close Call"
                sx={{
                  backgroundColor: "GrayText",
                  boxShadow: "none",
                  borderRadius: "0.5rem",
                  fontSize: 14,
                }}
                handleClick={() => handleCloseCall(item, item._id)}
              />
            </CustomButtonContainer>
          )}
        </ActionButtonContainer>
        {!showSelectCheckbox && (
          <Box
            sx={{
              position: "absolute",
              bottom: "0.5rem",
              right: "0.5rem",
              cursor: "pointer",
              color: colors.text.secondary,
              "&:hover": { color: colors.error }, // hover red
            }}
            onClick={() => onDelete(item._id)}
          >
            <Delete color={colors.gray} />
          </Box>
        )}
      </StockCard>
      <CloseCall
        open={open}
        setOpen={setOpen}
        selectedCall={selectedCall}
        setCallData={setCallData}
        callsname={callsname}
        closeCallApiType={closeCallApiType}
        fetchCallData={fetchCallData}
      />
    </Container>
  );
}

export default RecentCalls;

const Container = styled(Box)(({ theme }) => ({
  display: "flex",
  width: "100%",
  padding: "1rem",
  rowGap: "1rem",
  borderRadius: 16,
  backgroundColor: theme.palette.background.paper,
}));

const StockCard = styled(Box)(({ theme }) => ({
  display: "flex",
  width: "100%",
  borderRadius: 16,
  border: `1px solid ${colors.borderColor}`,
}));

// Header section layout
const Header = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
}));

// Info section styling
const Info = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  rowGap: "4px",
}));

// Date and Profit section styling
const DateProfit = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  columnGap: 4,
}));

const EntryPrice = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  rowGap: "4px",
}));

const Targets = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
}));

const Target = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
}));

const CheckboxContainer = styled(Box)(({ theme }) => ({
  width: "80%",
  display: "flex",
  flexDirection: "column",
  padding: "1rem",
  rowGap: "0.5rem",
}));

const ActionButtonContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  columnGap: "1rem",
  padding: "1rem",
  width: "20%",
  position: "relative",
}));

const CustomButtonContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
}));

const UpdatedDateTypography = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  color: colors.text.tertiary,
  fontWeight: 500,
  padding: "0.2rem 0.5rem",
  marginTop: "0.5rem",
  backgroundColor: "#F2F2F2",
}));
const BatchContainer = styled(Box)(({ theme, isItem }) => ({
  position: "absolute",
  top: 0,
  right: 0,
  padding: "4px 1rem",
  backgroundColor: isItem ? colors.text.orange : colors.lightGreen2,
  borderTopRightRadius: "1rem",
  borderBottomLeftRadius: "1rem",
}));
